{
  "name": "bunvm",
  "version": "1.0.2",
  "description": "Bun Version Manager - Switch between different versions of Bun easily",
  "bin": {
    "bvm": "./dist/bvm.js"
  },
  "type": "module",
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "scripts": {
    "build": "tsup",
    "dev": "tsx src/bvm.ts",
    "clean": "rm -rf dist",
    "prepublishOnly": "pnpm run clean && pnpm run build",
    "start": "node dist/bvm.js",
    "format": "prettier --write --ignore-path .gitignore --cache .",
    "lint": "eslint --ext .ts src --cache",
    "lint:fix": "eslint --ext .ts src --cache --fix"
  },
  "keywords": [
    "bun",
    "version",
    "manager",
    "version-manager",
    "bun version manager",
    "cli",
    "javascript",
    "typescript",
    "nodejs"
  ],
  "author": "Tarun Joshi",
  "license": "MIT",
  "homepage": "https://github.com/MrHacker26/bvm#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/MrHacker26/bvm.git"
  },
  "bugs": {
    "url": "https://github.com/MrHacker26/bvm/issues"
  },
  "files": [
    "dist"
  ],
  "packageManager": "pnpm@10.11.0",
  "dependencies": {
    "axios": "^1.9.0",
    "chalk": "^5.4.1",
    "cli-progress": "^3.12.0",
    "commander": "^13.1.0",
    "unzipper": "^0.12.3"
  },
  "devDependencies": {
    "@eslint/js": "^9.27.0",
    "@types/cli-progress": "^3.11.6",
    "@types/node": "^22.15.18",
    "@types/unzipper": "^0.10.11",
    "@typescript-eslint/eslint-plugin": "^8.32.1",
    "@typescript-eslint/parser": "^8.32.1",
    "eslint": "^9.27.0",
    "globals": "^16.1.0",
    "prettier": "^3.5.3",
    "tsup": "^8.5.0",
    "tsx": "^4.19.4",
    "typescript": "^5.0.0",
    "typescript-eslint": "^8.32.1"
  }
}
